<template>
  <div class="w-full h-full overflow-auto relative">
    <div
      class="fixed w-full h-full top-0 left-0"
      v-if="option.id"
      :style="{
        background: `linear-gradient(to bottom, ${option.gradient.join(', ')})`,
      }"
    ></div>
    <div
      class="h-full flex items-center max-w-2xl mx-auto flex-col justify-center relative"
    >
      <AppDataProperty
        contentId="platformSubscriptions"
        @dataAvailable="
          data => {
            if (!data?.metaData?.subscriptions) return
            options = data?.metaData?.subscriptions
            makeOptionSelect()
          }
        "
        isComponent
      />
      <div class="w-full">
        <div v-if="option.id" class="flex flex-col gap-2">
          <div>
            <img :src="option.image" class="h-[10vh] mx-auto" alt="" />
          </div>
          <div class="text-center text-3xl font-bold">
            Abonnement {{ option.name }}
          </div>

          <!-- {{ option }} -->
        </div>
        <div class="hidden">
          <SubscriptionSelector ref="subscriptionSelector" />
        </div>

        <div v-if="!option.id || paymentPending" class="py-32">
          <Loader />
        </div>

        <div
          v-else-if="paymentSucceeded"
          class="flex flex-col items-center justify-center py-12 pt-24"
        >
          <div class="w-[8rem]">
            <img src="@/assets/images/all/check.png" alt="" />
          </div>
          <div class="py-4"></div>
          <div class="text-3xl title-color">Paiement réussi</div>
          <div class="text-center">
            Vous recevrez un email de confirmations sur
            {{ filledData?.recipientEmail }}
          </div>
        </div>

        <div
          v-else-if="paymentFailed"
          class="flex flex-col items-center justify-center py-12 pt-24"
        >
          <div class="w-[7rem]">
            <img src="@/assets/images/all/close-blue.svg" alt="" />
          </div>
          <div class="py-4"></div>
          <div class="text-3xl text-center title-color">Paiement échoué</div>
          <div class="py-1" v-if="failureDescription">
            <div class="text-center title-color">
              Désolé, votre paiement n'a pas été confirmé. Veuillez réessayer
            </div>
          </div>
        </div>
        <div v-else-if="fillForm" class="">
          <SubscriptionForm
            ref="subscriptionForm"
            @dataFilled="onDataFilled"
            hidePaymentMethod
            isDirectSubscription
            requestPhoneCountry
            v-if="service.serviceId == 'subscription'"
            :subscriptionOption="option"
          />
        </div>
        <div class="text-center" v-if="option.id">
          <a href="https://web.kingrecharges.com" class="underline"
            >Propulsé par Kingrecharges.com</a
          >
        </div>
      </div>
      <TransactionLauncheListener
        @transactionLaunched="onTransactionLaunched"
      />
      <LaunchedTransactionResolver
        @transactionPaymentDone="onTransactionPaymentDone"
      />
      <EventListener
        uniqId="transaction_launcher_handler"
        :events="['service_launching_requested', 'launch_transaction_request']"
        @service_launching_requested="onServiceRequested"
        @launch_transaction_request="onTransactionRequestSent"
      />
      <OtpValidation ref="otpValidator" @otp_validated="onOtpValidated" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TransactionLauncheListener from './TransactionLauncheListener.vue'
import FundXBetForm from './forms/FundXBetForm.vue'
import FundBetwinnerForm from './forms/FundBetwinnerForm.vue'
import BuyUsdtForm from './forms/BuyUsdtForm.vue'
import WithdrawXBetForm from './forms/WithdrawXBetForm.vue'
import withdrawBetwinnerForm from './forms/WithdrawBetwinnerForm.vue'
import SellUsdtForm from './forms/SellUsdtForm.vue'
import EventListener from '../../utils/EventListener.vue'
import FundWalletForm from './forms/FundWalletForm.vue'
import withdrawWalletForm from './forms/WithdrawWalletForm.vue'
import SellGiftCardForm from './forms/SellGiftCardForm.vue'
import WithdrawAffiliationFrom from './forms/WithdrawAffiliationFrom.vue'
import FundOneWin from './forms/FundOneWin.vue'
import Withdraw1WinForm from './forms/Withdraw1WinForm.vue'
import BuyGiftCardForm from './forms/BuyGiftCardForm.vue'
import SubscriptionSelector from './SubscriptionSelector.vue'
import SubscriptionForm from './forms/SubscriptionForm.vue'
import AppDataProperty from '@/components/appData/AppDataProperty.vue'
import OtpValidation from '@/components/utils/OtpValidation.vue'
import Loader from '@/components/utils/Loader.vue'
import LaunchedTransactionResolver from './LaunchedTransactionResolver.vue'

export default defineComponent({
  name: 'SpecificTransactionLauncher',
  components: {
    Loader,
    TransactionLauncheListener,
    EventListener,
    FundXBetForm,
    FundBetwinnerForm,
    BuyUsdtForm,
    WithdrawXBetForm,
    withdrawBetwinnerForm,
    SellUsdtForm,
    FundWalletForm,
    withdrawWalletForm,
    SellGiftCardForm,
    BuyGiftCardForm,
    WithdrawAffiliationFrom,
    FundOneWin,
    Withdraw1WinForm,
    SubscriptionSelector,
    SubscriptionForm,
    AppDataProperty,
    OtpValidation,
    LaunchedTransactionResolver,
  },
  props: {},
  data() {
    return {
      selectOption: false,
      sendingOtp: false,
      fillForm: false,
      service: { serviceId: 'subscription' },
      option: {},
      filledData: {},
      options: [],
      platformSubscriptions: [],
      paymentSucceeded: false,
      paymentFailed: false,
      paymentPending: false,
    }
  },
  mounted() {},
  methods: {
    makeOptionSelect() {
      const option = this.options.find(
        opt => opt.platformId == this.getPlatform(),
      )
      this.option =
        this.$refs.subscriptionSelector.selectOptionAndConfig(option)
      this.fillForm = true
      this.$Commons.setThemeColor((option?.gradient || [])[0])
    },
    getPlatform() {
      try {
        if (/netflix/i.test(window.location.href)) return 'netflix'
        if (/prime-video/i.test(window.location.href)) return 'prime-video'
        if (/disney-plus/i.test(window.location.href)) return 'disney-plus'
        if (/crunchyroll/i.test(window.location.href)) return 'crunchyroll'
        if (/spotify/i.test(window.location.href)) return 'spotify'
        if (/nordvpn/i.test(window.location.href)) return 'nordvpn'
        if (/privatevpn/i.test(window.location.href)) return 'privatevpn'
        if (/cyberghost/i.test(window.location.href)) return 'cyberghost'
        if (/adn/i.test(window.location.href)) return 'adn'
        return 'netflix'
      } catch (error) {
        return 'netflix'
      }
    },
    async onServiceRequested(service) {
      console.log(service)
      this.service = service
      this.selectOption = true
      this.fillForm = false
      // if (option) {
      //   this.option = option
      //   this.selectOption = false
      //   this.fillForm = true
      // }
    },
    checkAndRequireNotif() {
      const canAcceptNotification =
        this.$NotificationUtils.canAcceptNotification()
      if (!canAcceptNotification) return false
      const notificationAccepted =
        this.$NotificationUtils.notificationPermissionIsAccepted()
      if (!notificationAccepted) {
        this.$Events.dispatchEvent(
          'ask_notification_permission_to_user_required',
        )
      }
      return !notificationAccepted
    },
    async get1xBetAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const xbetAccountId = userPreferences?.xbetAccountId
      return xbetAccountId
    },
    async getBetwinnerAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const betwinnerAccountId = userPreferences?.betwinnerAccountId
      return betwinnerAccountId
    },
    async get1WinAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const oneWinAccountId = userPreferences?.oneWinAccountId
      return oneWinAccountId
    },
    onNoOptionFound() {
      this.option = {}
      this.selectOption = false
      this.fillForm = true
    },
    transactionOptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    giftCardSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    subscriptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    onTransactionRequestSent() {
      // this.$refs.bottomSheet.hide()
    },
    onDataFilled(data) {
      if (this.sendingOtp) return
      this.sendingOtp = true
      this.filledData = data
      this.$refs.otpValidator.validateEmail({
        email: this.filledData.recipientEmail,
        firstName: 'Mr/Mme',
        // reason: 'passwordReset',
      })
      setTimeout(() => {
        this.sendingOtp = false
      }, 1000)
    },
    async onOtpValidated({ otp, token }) {
      const transactionData = {
        ...this.filledData,
        email: this.filledData.recipientEmail,
        isDirectSubscription: true,
        otp,
        token,
      }
      console.log(transactionData)
      await new Promise(r => setTimeout(r, 500))
      this.$refs.subscriptionForm.startLoading()
      this.$Events.dispatchEvent('launch_transaction_request', transactionData)
      this.$Events.dispatchEvent('start_loading')
    },
    onTransactionLaunched() {
      this.paymentPending = true
    },
    onTransactionPaymentDone(data) {
      const status = data?.status
      if (!status) return
      this.paymentPending = false
      if (status == 'success') {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Paiement réussi',
          body: "Nous vous enverront un email pour que vous accédez à l'application Kingrecharge",
        })
        this.paymentSucceeded = true
      } else {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Paiement échoué',
          body: 'Le paiement a échoué. Veuillez réessayer à nouveau.',
        })
        this.paymentFailed = true
      }
    },
  },
})
</script>
